import CustomButton from "../lib/customButton";

const ConfirmDeleteModal = ({
    isOpen,
    title = "Confirmação",
    message,
    warning,
    confirmText = "Excluir",
    cancelText = "Cancelar",
    onConfirm,
    onCancel,
    disableConfirm = false,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-lg w-full max-w-xl p-8 shadow-lg">
                {title && (
                    <h2 className="text-2xl font-semibold mb-4 text-custom_gray_font">
                        {title}
                    </h2>
                )}

                {message && (
                    <p className="text-lg mb-2 text-custom_gray_font">
                        {message}
                    </p>
                )}

                {warning && (
                    <p className="text-sm text-custom_red mb-6">
                        {warning}
                    </p>
                )}

                {/* Footer */}
                <div className="flex justify-end gap-4 mt-8">
                    <CustomButton
                        buttonType="delete"
                        text={confirmText}
                        onClick={onConfirm}
                        disabled={disableConfirm}
                    />

                    <CustomButton
                        text={cancelText}
                        onClick={onCancel}
                        className="bg-custom_gray_font"
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
